import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import initApp from 'utils/functions/init';
import { contexts } from 'constants/context';
import { fetchCampaignsList } from 'modules/campaigns/actions';
import CampaignsView from 'modules/campaigns/views/CampaignsView';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const CampaignsPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const advertiserKey = searchParams.get('advertiserKey');

  const campaignsListApiCallBody = useMemo(() => {
    const data = {
      page: 1,
      pageSize: 10,
    };
    if (advertiserKey) data.advertiserKey = advertiserKey;

    return data;
  }, [advertiserKey]);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const body = {
      data: campaignsListApiCallBody,
    };
    dispatch(fetchCampaignsList(body));

    initApp(contexts.campaigns);
  }, [campaignsListApiCallBody, dispatch]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <CampaignsView campaignsListApiCallBody={campaignsListApiCallBody} />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

CampaignsPage.propTypes = {};

CampaignsPage.defaultProps = {};

export default CampaignsPage;
